var app = angular.module("leonardo");

var ManageAccountListController = function($scope, $filter, $rootScope, $q, ngDialog, AccountInvitationService, AccountUserService,
                                           AccountService, AuthDataService, NotificationService, FormErrorsService, $timeout) {

  $scope.accountInvitationService = AccountInvitationService;
  $scope.accountUserService = AccountUserService;
  $scope.alias = AuthDataService.authData.account ? AuthDataService.authData.account.alias : '';
  $scope.account_invitations = [];
  $scope.received_invitations = [];
  $scope.history_invitations = [];
  $scope.accounts_managed = [];
  $scope.managers_account = [];

  $scope.statusesInvitations = [
    {
      id: AccountInvitationService.STATUS_ACCEPTED,
      name: 'Accepted'
    },
    {
      id: AccountInvitationService.STATUS_DECLINED,
      name: 'Declined'
    }
  ];

  $scope.showHistory = false;

  $scope.toggleHistory = function () {
    $scope.showHistory = !$scope.showHistory;
  };

  $scope.orderBy = function (order, array) {
    var reverse = false;
    $scope.order_array = array;
    if ($scope.order !== order){
      $scope.order = order;
    }
    else {
      $scope.order = '-' + order;
      reverse = true;
    }
    switch (array) {
      case 'received':
        $scope.received_invitations = $filter('orderBy')($scope.received_invitations, order, reverse);
        break;
      case 'invitation':
        $scope.account_invitations = $filter('orderBy')($scope.account_invitations, order, reverse);
        break;
      case 'history':
        $scope.history_invitations = $filter('orderBy')($scope.history_invitations, order, reverse);
        break;
      case 'account':
        $scope.accounts_managed = $filter('orderBy')($scope.accounts_managed, order, reverse);
        break;
      case 'manager':
        $scope.managers_account = $filter('orderBy')($scope.managers_account, order, reverse);
        break;
    }
  };

  $scope.isOrder = function (order, array) {
    return ($scope.order === order) && ($scope.order_array === array);
  };

  $scope.refreshHistory = function() {
    var defer = $q.defer();
    $scope.history_invitations = [];
    var status = $scope.status ?
      $scope.status : [AccountInvitationService.STATUS_ACCEPTED, AccountInvitationService.STATUS_DECLINED].join(',');
    AccountInvitationService.getlist({
      disable_pagination: true,
      status: status,
      summary: true
    }, true).then(function(data){
      $scope.history_invitations = data.results ? data.results : data;
      angular.forEach($scope.history_invitations, function (value) {
        value.status_description = $filter('accountInvitationStatus')(value.status) + ' ' + $filter('date')(value.modified, 'MMM dd, yyyy');
        value.info = $scope.getInfo(value, true);
      });
      defer.resolve();
    }, function(error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  $scope.refresh = function(only_filter) {
    $scope.account_invitations = [];
    $scope.received_invitations = [];
    var promises = [];
    promises.push($scope.refreshHistory());
    promises.push(AccountInvitationService.getlist({
      disable_pagination: true,
      status: [AccountInvitationService.STATUS_LOADING, AccountInvitationService.STATUS_PENDING].join(','),
      summary: true
    }, true).then(function(data){
      angular.forEach(data, function (value) {
        if (value.from_account.id == AccountUserService.currentAccountUser.account) {
          $scope.account_invitations.push(value);
        }
        else {
          $scope.received_invitations.push(value);
        }
      });
    }));
    if (!only_filter && $scope.accountUserService.currentAccountUser.account) {
      promises.push(AccountService.get($scope.accountUserService.currentAccountUser.account).then(function (data) {
        $scope.accounts_managed = data.managed_by_me;
        $scope.managers_account = data.managed_to_me;
        if (data?.managed_by_me?.length > 0) {
          filterData(data.managed_by_me);
        }
        if (data?.managed_to_me?.length > 0) {
          filterData(data.managed_to_me);
        }
      }));
    }
    $q.all(promises).then(function () {
      angular.forEach($scope.account_invitations, function (value) {
        value.status_description = $filter('accountInvitationStatus')(value.status) + ' ' + $filter('date')(value.modified, 'MMM dd, yyyy');
        value.info = $scope.getInfo(value, true);
      });
      angular.forEach($scope.received_invitations, function (value) {
        value.status_description = $filter('accountInvitationStatus')(value.status) + ' ' + $filter('date')(value.modified, 'MMM dd, yyyy');
        value.info = $scope.getInfo(value, true);
      });
      angular.forEach([$scope.accounts_managed,$scope.managers_account], (data) => {
        data = $scope.modifyData(data);
      })
    });
  };

  function filterData(record){
    angular.forEach(record, function(value) {
      if (value.properties.length > 0) {
        angular.noop();
      }
      if (value.portfolios.length > 0) {
        value.full_management = value.portfolios[0].full_management;
      }
    });
  }

  $scope.modifyData = function(data){
    angular.forEach(data, function (value) {
      value.portfolios_info = '';
      angular.forEach(value.portfolios, function(portfolio){
        value.portfolios_info += portfolio.name + ",";
      });
      value.properties_info = '';
      angular.forEach(value.properties, function(property){
        value.properties_info += property.name + ",";
      });
    });
    return data;
  }

  $scope.tooltipMessage = 'We are linking the property data and templates in your account. This can take up to 20 minutes to complete.';

  $scope.showInfoDialog = function(invitation) {
    ngDialog.open({
      template: 'views/templates/dialog/account-user/share-account-info.html',
      controller: 'ManageInfoDialog',
      data: {
        invitation: invitation
      }
    });
  };

  $scope.showManageAccount = function() {
    $scope.FormAlias.$setSubmitted();
    if ($scope.FormAlias.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    ngDialog.openConfirm({
      template: 'views/templates/dialog/account-user/share-account.html',
      controller: 'ManageAccountDialog',
      className: 'ngdialog-theme-default ngdialog-admin',
      data: {
        alias: $scope.user_alias
      }
    }).then(function(){
      $scope.refresh();
    });
  };

  $scope.showDeleteInvitation = function(account_from, account_to, portfolios, properties){
    ngDialog.openConfirm({
      template: 'views/templates/dialog/admin/delete-invitation.html',
      controller: 'DeleteInvitationDialog',
      data: {
        portfoliosAvailable: portfolios,
        propertiesAvailable: properties,
        account_from: account_from,
        account_to: account_to
      }
    }).then(function(){
      location.reload();
    });
  };

  $scope.dismissInvitation = function(invitation) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/admin/decline-invitation.html',
      controller: 'DeclineInvitationDialog',
      data: {
        invitation: invitation
      }
    }).then(function(){
      $scope.refresh();
    });
  };

  $scope.acceptInvitation = function(invitation) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/admin/accept-invitation.html',
      controller: 'AcceptInvitationDialog',
      data: {
        invitation: invitation
      }
    }).then(function(){
      $scope.refresh();
    });
  };

  $scope.getInfo = function(invitation, string){
    var info = '';
    if (invitation && invitation.management_info) {
      if (string) {
        if (invitation.management_info.portfolios && invitation.management_info.portfolios.length > 0){
          info += '<div class="string"><strong>Portfolios : </strong>';
        }
        angular.forEach(invitation.management_info.portfolios, function(portfolio){
          info += portfolio.name + ", ";
        });
        if (invitation.management_info.portfolios && invitation.management_info.portfolios.length > 0){
          info = info.slice(0, -2) + '</div>';
        }
      }
      else {
        if (invitation.management_info.portfolios && invitation.management_info.portfolios.length > 0){
          info += '<div class="bold">' + $filter('translate')('Portfolios') + ': </div>';
        }
        info += '<div read-more>';
        angular.forEach(invitation.management_info.portfolios, function(portfolio){
          info += "<span>" + portfolio.name + "</span>";
        });
        info += '</div>';
      }
      if (string) {
        if (invitation.management_info.properties && invitation.management_info.properties.length > 0){
          info += '<div class="string"><strong>Properties : </strong>';
        }
        angular.forEach(invitation.management_info.properties, function(property){
          info += property.name + ", ";
        });
        if (invitation.management_info.properties && invitation.management_info.properties.length > 0){
          info = info.slice(0, -2) + '</div>';
        }
      }
      else {
        if (invitation.management_info.properties && invitation.management_info.properties.length > 0){
          info += '<div class="bold">' + $filter('translate')('Properties') + ': </div>';
        }
        info += '<div read-more>';
        angular.forEach(invitation.management_info.properties, function (property) {
          info += "<span>" + property.name + "</span>";
        });
        info += '</div>';
      }
    }
    return info;
  };

  $scope.share = function() {
    $scope.FormShare.$setSubmitted();
    if ($scope.FormShare.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    AuthDataService.authData.accountsManager[0].share({to: $scope.user_email}).then(function () {
      $scope.user_email = '';
      $scope.FormShare.$submitted = false;
      NotificationService.notify('success', 'Your alias have been sent.');
    });
  };

  $timeout(function () {
    $scope.refresh();
  }, 0);
};

app.controller('ManageAccountListController', ['$scope', '$filter', '$rootScope', '$q', 'ngDialog',
  'AccountInvitationService', 'AccountUserService', 'AccountService', 'AuthDataService', 'NotificationService',
  'FormErrorsService', '$timeout', ManageAccountListController]);
